import React, {Component} from 'react';
import {EditorState, convertFromRaw} from 'draft-js';
import Editor, {EditorPlugin} from 'draft-js-plugins-editor';
import createInlineToolbarPlugin, {Separator, InlineToolBarPlugin, ToolbarProps} from 'draft-js-inline-toolbar-plugin';
import {
    ItalicButton,
    BoldButton,
    UnderlineButton,
    CodeButton,
    UnorderedListButton,
    OrderedListButton,
    BlockquoteButton,
    CodeBlockButton
} from 'draft-js-buttons';
import 'draft-js/dist/Draft.css';
import 'draft-js-inline-toolbar-plugin/lib/plugin.css';
import HeadlinesButton from './headlines-button';

interface Props {
    editorState?: EditorState;
    readOnly: boolean;
    toolbar: boolean;
    onChange: (editorState: EditorState) => void;
    onBlur: () => void;
    onFocus: () => void;
    feedback?: string;
}

const FEEDBACK_TEXT_LIMIT = 5000;

class FeedbacksEditor extends Component<Props> {
    static defaultProps = {
        readOnly: true,
        toolbar: false,
        onChange: () => null,
        onBlur: () => null,
        onFocus: () => null,
        editorState: EditorState.createEmpty()
    };

    inlineToolbarPlugin: InlineToolBarPlugin;
    InlineToolbar: React.ComponentType<ToolbarProps>;
    plugins: EditorPlugin[];
    editor!: Editor;

    constructor(props: Props) {
        super(props);

        this.inlineToolbarPlugin = createInlineToolbarPlugin();
        this.InlineToolbar = this.inlineToolbarPlugin.InlineToolbar;
        this.plugins = [this.inlineToolbarPlugin];
    }

    focus = () => this.editor.focus();

    handleBeforeInput = (chars: string, editorState: EditorState) => {
        const contentState = editorState.getCurrentContent();
        const length = contentState.getPlainText().length + chars.length;
        return length > FEEDBACK_TEXT_LIMIT ? 'handled' : 'not-handled';
    };

    handlePastedText = (text: string, html: string, editorState: EditorState) => {
        const plainText = editorState.getCurrentContent().getPlainText();
        const length = plainText.length + text.length;
        return length > FEEDBACK_TEXT_LIMIT ? 'handled' : 'not-handled';
    };

    render() {
        const {readOnly, toolbar, feedback, onChange, onBlur, onFocus} = this.props;

        const InlineToolbar = this.InlineToolbar;

        const contentState = feedback ? convertFromRaw(JSON.parse(feedback)) : EditorState.createEmpty();

        const editorState = feedback ? EditorState.createWithContent(contentState) : this.props.editorState;

        return (
            <div onClick={this.focus}>
                <Editor
                    editorState={editorState}
                    onChange={onChange}
                    onBlur={onBlur}
                    handleBeforeInput={this.handleBeforeInput}
                    handlePastedText={this.handlePastedText}
                    onFocus={onFocus}
                    readOnly={readOnly}
                    plugins={this.plugins}
                    ref={(element: Editor) => (this.editor = element)}
                />
                {toolbar ? (
                    <InlineToolbar>
                        {(externalProps: any) => (
                            <React.Fragment>
                                <BoldButton {...externalProps} />
                                <ItalicButton {...externalProps} />
                                <UnderlineButton {...externalProps} />
                                <CodeButton {...externalProps} />
                                <Separator {...externalProps} />
                                <HeadlinesButton {...externalProps} />
                                <UnorderedListButton {...externalProps} />
                                <OrderedListButton {...externalProps} />
                                <BlockquoteButton {...externalProps} />
                                <CodeBlockButton {...externalProps} />
                            </React.Fragment>
                        )}
                    </InlineToolbar>
                ) : null}
            </div>
        );
    }
}

export default FeedbacksEditor;
